import { BehaviorSubject } from "rxjs";
import { ApplicantJobData, JobPostData } from "../../lib/types";

export const jobboardJobs$ = new BehaviorSubject<JobPostData[] | ApplicantJobData[]>([]);

export const jobboardCount$ = new BehaviorSubject<number>(-1);

export const jobboardPageSize = 10;

export const job$ = new BehaviorSubject<JobPostData | null>(null);